export default {
  'account.enhanced': {
    tracking_removal_label: 'remove-product',
    term_selection: true
  },
  'dns.premium': {
    tracking_removal_label: 'remove-product',
    term_selection: true
  },
  'team.login': {
    term_selection: true
  },
  'support.priority': {
    tracking_removal_label: 'remove-product-support',
    term_selection: true
  },

  'host.redemption': {
    // FIXME this was identical to priority support - an error?
    tracking_removal_label: 'remove-product-support'
  },

  'dns.pro': {
    tracking_removal_label: 'remove-product-pro-dns',
    term_selection: true
  },

  'dns.tier': {
    tracking_removal_label: 'remove-product-plus-dns',
    domain_input: true,
    term_selection: true
  },

  'monitor.basic': {
    tracking_removal_label: 'remove-product-monitoring',
    domain_input: true,
    term_selection: true
  },

  'monitor.advanced': {
    tracking_removal_label: 'remove-product-monitoring',
    domain_input: true,
    term_selection: true
  },

  'mail.pop': {
    tracking_removal_label: 'remove-product-mail',
    domain_input: true,
    term_selection: true
  },

  'mail.forwarding': {
    tracking_removal_label: 'remove-product-mail',
    domain_input: true,
    term_selection: true
  },

  'mail.smtp': {
    tracking_removal_label: 'remove-product-mail',
    domain_input: true,
    term_selection: true
  },

  'mail.backupmx': {
    tracking_removal_label: 'remove-product-mail',
    domain_input: true,
    term_selection: true
  },

  'mail.reflector': {
    tracking_removal_label: 'remove-product-mail',
    domain_input: true,
    term_selection: true
  },

  'dns.squared': {
    tracking_removal_label: 'remove-product-squared',
    domain_input: true,
    term_selection: true
  },

  'ssl.quick': {
    tracking_removal_label: 'remove-product-ssl',
    term_selection: true
  },

  'ssl.rapid': {
    tracking_removal_label: 'remove-product-ssl',
    term_selection: true
  },

  'ssl.rapid_dv': {
    tracking_removal_label: 'remove-product-ssl',
    term_selection: true
  },

  'ssl.premium_dv': {
    tracking_removal_label: 'remove-product-ssl',
    term_selection: true
  },

  'ssl.rapid_wildcard': {
    tracking_removal_label: 'remove-product-ssl',
    term_selection: true
  },

  'ssl.rapid_wildcard_dv': {
    tracking_removal_label: 'remove-product-ssl',
    term_selection: true
  },

  'ssl.premium': {
    tracking_removal_label: 'remove-product-ssl',
    domain_input: true,
    term_selection: true
  },

  'ssl.trustcor_premium': {
    tracking_removal_label: 'remove-product-ssl',
    term_selection: true
  },

  'ssl.trustcor_standard': {
    tracking_removal_label: 'remove-product-ssl',
    term_selection: true
  },

  'ssl.trustcor_wildcard': {
    tracking_removal_label: 'remove-product-ssl',
    term_selection: true
  },

  'registration.domain': {
    tracking_removal_label: 'remove-product-dom-reg',
    domain_input: true,
    term_selection: true,
    privacy_upsell: true
  },

  'whitelabel.domain': {
    tracking_removal_label: 'remove-product',
    term_selection: true
  },

  // FIXME also the same as registration - another error?
  'registration.transfer': {
    tracking_removal_label: 'remove-product-dom-reg',
    domain_input: true,
    term_selection: true,
    privacy_upsell: true
  }
};
